<template>
  <div>
    edit value
    <v-text-field type="number" v-model="localValue.value" />
  </div>
</template>

<script>
export default {
  props: ["value"],
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      }
    }
  }
};
</script>